<template>
	<v-navigation-drawer v-model="drawer" app touchless permanent mini-variant>
		<v-layout column fill-height>
			<v-list dense nav class="pa-0">
				<v-list-item class="white-bg">
					<v-list-item-content>
						<v-list-item-title class="d-flex justify-center align-center">
							<v-img class="flex-grow-1 px-1 py-2" contain width="60" max-height="40" src="../assets/img/logo-simple.svg"></v-img>
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<v-list dense nav class="pa-0 black-bg nav-menu">
				<div class="d-flex justify-end pa-6 pb-2">
					<v-btn icon v-if="!mini">
						<v-icon large color="white">mdi-chevron-left</v-icon>
					</v-btn>
				</div>
				<span v-for="item in navItems" :key="item.id">
					<v-list-item class="px-3" link :to="item.path" :disabled="isItemDisabled(item)">
						<v-tooltip right>
							<template v-slot:activator="{ on, attrs }">
								<v-list-item-icon v-bind="attrs" v-on="on">
									<v-icon :color="item.iconColor ?? 'white'">{{ item.icon }}</v-icon>
								</v-list-item-icon>
							</template>
							<span>{{ $t(item.title || "") }}</span>
						</v-tooltip>

						<v-list-item-content>
							<v-list-item-title>{{ $t(item.title || "") }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</span>
			</v-list>

			<v-spacer class="black-bg"></v-spacer>

			<v-list dense nav class="black-bg">
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-list-item v-bind="attrs" v-on="on" class="px-2" link @click.stop="logout" :disabled="loading">
							<v-list-item-icon>
								<v-icon color="white">mdi-logout-variant</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title>{{ $t("login.logout") }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
					<span>{{ $t("login.logout") }}</span>
				</v-tooltip>
			</v-list>
		</v-layout>
	</v-navigation-drawer>
</template>

<script lang="ts">
import Vue from "vue";
import { UIPAGE } from "@/constants/ui-page.constants";
import { filterRoutes } from "@/router/index";
import { permissionCanActivate } from "@/router/guards/permissionGuard";
import { RouteInfo } from "@/router/types";

export default Vue.extend({
	name: "NavMenu",
	components: {},
	data: () => ({
		drawer: true,
		mini: true,
		navItems: [] as RouteInfo[]
	}),
	computed: {
		loading(): boolean {
			return this.$store.state.components.overlay.active;
		},
		currentRoute(): string {
			return this.$route.path;
		}
	},
	mounted() {
		const nav = [
			UIPAGE.DASBOARD,
			UIPAGE.SALE,
			UIPAGE.GENERIC_SALE,
			UIPAGE.TRACKING_LEADS,
			UIPAGE.TRACKING_SALES,
			UIPAGE.COVERAGE_SEARCH,
			UIPAGE.APPROVALS,
			UIPAGE.CUSTOMERS,
			UIPAGE.PRODUCTS,
			UIPAGE.TRACKING_CUSTOMERS_AGGRUPATIONS,
			UIPAGE.RETAIL,
			UIPAGE.ADMINISTRATION
		];
		this.navItems = filterRoutes(...nav)
			.sort((a, b) => {
				const { id: firstItemId } = a;
				const { id: secondItemId } = b;
				const firstItemIndex = nav.findIndex((item) => item === firstItemId);
				const secondItemIndex = nav.findIndex((item) => item === secondItemId);

				return firstItemIndex <= secondItemIndex ? -1 : 1;
			})
			.filter((route) => {
				const { id } = route;

				return permissionCanActivate({ routeId: id });
			});
	},
	methods: {
		isItemDisabled(item: RouteInfo): boolean {
			if (this.loading) {
				return true;
			}

			if (this.currentRoute.startsWith("/sale/") && item.path === "/sale") {
				return true;
			}

			if (this.currentRoute.startsWith("/generic-sale/") && item.path === "/generic-sale") {
				return true;
			}

			return false;
		},
		logout() {
			this.$store.dispatch("logout").then(() => {
				this.$router.push("/login", () => {});
				if (this.$route.matched[0].name === "sale") return;
			});
		}
	}
});
</script>
<style scoped lang="scss">
@import "~vuetify/src/styles/settings/_variables";

.v-navigation-drawer--fixed {
	z-index: 500;
}

::v-deep .v-navigation-drawer__border {
	width: 0px !important;
}

::v-deep .v-list-item .v-icon {
	opacity: 0.5;
	transition: opacity 0.2s;
}

::v-deep .v-list-item.v-list-item--active .v-icon {
	opacity: 1;
}

.nav-menu {
	border-top-right-radius: var(--adm-border-radius) !important;
}
</style>
